// Copyright (c) 2017 Deere & Company

const pipCompletionStatuses = [
    '',
    '02',
    '03',
    '04'
];

export default pipCompletionStatuses;



// WEBPACK FOOTER //
// ./src/shared/utils/pip-completion-statuses.js